export const formatNumber = (value: number) => {
  return parseFloat(value.toFixed(3));
};
